"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const components_common_image_1 = require("@hotelplan/components.common.image");
const components_common_link_1 = require("@hotelplan/components.common.link");
const components_common_router_link_1 = require("@hotelplan/components.common.router-link");
const libs_router_link_utils_1 = require("@hotelplan/libs.router-link-utils");
const util_theme_sxc_1 = require("@hotelplan/util.theme.sxc");
const SocialMediaList = styled_components_1.default.div.attrs({
    className: 'social-media-list',
})((0, util_theme_sxc_1.sx2CssThemeFn)({
    py: [3, 3, 0],
    px: [4, 4, 0],
    display: 'flex',
    justifyContent: ['center', 'center', 'flex-start'],
    alignItems: 'center',
}));
const SocialMediaItemLink = (0, styled_components_1.default)(components_common_link_1.Link)(({ theme }) => theme.link.imgLink, (0, util_theme_sxc_1.sx2CssThemeFn)({
    flex: '0 0 auto',
    '&:not(:last-child)': {
        marginRight: [3, 4],
    },
}));
const SocialMediaItemImage = (0, styled_components_1.default)(components_common_image_1.Image)({ height: '31px' });
const SocialMedia = ({ items }) => {
    return (react_1.default.createElement(SocialMediaList, null, items.map((item, index) => {
        const { caption, link, iconId } = item;
        const routerLink = link ? (0, libs_router_link_utils_1.getRouterLink)(link) : undefined;
        return (react_1.default.createElement(components_common_router_link_1.RouterLink, Object.assign({}, routerLink, { passHref: true, key: `${iconId}_${index}` }),
            react_1.default.createElement(SocialMediaItemLink, { "data-id": item.link ? 'social-media-link-id' : 'social-media-id', target: item.link ? (0, libs_router_link_utils_1.getOpenMethod)(item.link) : undefined, onClick: e => {
                    if (!item.link)
                        e.preventDefault();
                } },
                react_1.default.createElement(SocialMediaItemImage, Object.assign({ className: "social-media-icon" }, item.icon)),
                caption)));
    })));
};
exports.default = SocialMedia;
//# sourceMappingURL=SocialMedia.js.map